<script>
    export default {
        name: "CategoriesContents",
        props: {
            activeIndex: {
                type: Number,
                required: true
            },
            contents: {
                type: Array,
                required: true
            }
        },
        methods: {
            renderWrapper(h, children) {
                return h('div', {
                    class: 'categories-contents'
                }, children)
            },
            renderItem(h, item, index) {
                return this.activeIndex === index ? h(item.tag, {
                    attrs: {
                        class: item.data.staticClass
                    },
                    key: index
                }, item.children) : null;
            }
        },
        render(h) {
            return this.renderWrapper(h, this.contents.map((item, index) => this.renderItem(h, item, index)));
        }
    }
</script>
